import React from "react";
import { Modal, Button } from "react-bootstrap";

const ReusableModal = ({
  show,
  onHide,
  title = "Notice",
  message,
  okText = "OK",
  cancelText,
  onOk,
  onCancel,
  centered = true,
  backdrop = "static", // prevent outside click close by default
  size = "md",
}) => {
  const handleOkClick = () => {
    if (onOk) {
      onOk(); // dynamic action
    }
    if (!onOk) {
      onHide(); // default close
    }
  };

  const handleCancelClick = () => {
    if (onCancel) {
      onCancel();
    } else {
      onHide();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered={centered}
      backdrop={backdrop}
      size={size}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {typeof message === "string" ? <p>{message}</p> : message}
      </Modal.Body>

      <Modal.Footer>
        {cancelText && (
          <Button variant="secondary" onClick={handleCancelClick}>
            {cancelText}
          </Button>
        )}

        <Button variant="primary" onClick={handleOkClick}>
          {okText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReusableModal;